import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { FormControl } from '@material-ui/core'
import { FieldError } from './FieldError'
import './FormFields.css'

interface DatePickerFieldProps {
  control: any
  label?: string
  format?: string
  id?: string
  error?: any
}

export const DatePickerField: React.FC<DatePickerFieldProps> = ({ control, label, id = 'date-picker-dialog', format = 'MM/dd/yyyy', error }) => {
  const [dateError, setDateError] = useState('')
  return (
    <>
      <FormControl color="primary" className="inputField" id={id}>
        <Controller
          name="dob"
          control={control}
          initialFocusedDate={null}
          defaultValue={null}
          as={
            <KeyboardDatePicker 
              id={id} 
              format={format} 
              label={label} 
              type="tel"
              disableFuture
              KeyboardButtonProps={{ type: 'button', value: 'Date Picker', "aria-label": 'Date Picker'}}
              maxDateMessage='Date should not be in the future.'
              minDateMessage='Date is too far in the past.'
              onError={(err: any) => setDateError(err)} 
              value={() => undefined} onChange={() => undefined} 
            />
          }
        />
      </FormControl>
      <FieldError fieldError={ dateError || error } />
    </>
  )
}
